/**
 * A saved cart outlives the catalog it was built from. When a product stops
 * being sold in a market (`unavailable_markets`), `get-products` no longer
 * returns it, but a session saved before that still holds its id. The price
 * and the cart UI only look at the catalog, so the stale id is invisible and
 * unbilled, yet it is still submitted in `product_ids` and reaches Attio, the
 * lab order and the invoice. Seen when the B-vitamins add-on was replaced by
 * B-vitamins & homocysteine: resumed carts booked both.
 *
 * Returns `null` when nothing changes. An empty catalog means it has not
 * loaded (or failed to), so nothing is dropped.
 */
export const dropUnavailableCartItems = (
  selectedProducts: string[],
  selectedAddOns: string[],
  catalog: { id: string }[],
): { selectedProducts: string[]; selectedAddOns: string[] } | null => {
  if (catalog.length === 0) return null;
  const sold = new Set(catalog.map((p) => p.id));
  const products = selectedProducts.filter((id) => sold.has(id));
  const addOns = selectedAddOns.filter((id) => sold.has(id));
  if (
    products.length === selectedProducts.length &&
    addOns.length === selectedAddOns.length
  ) {
    return null;
  }
  return { selectedProducts: products, selectedAddOns: addOns };
};
